module.exports = __webpack_public_path__ + "assets/img/patient-empty-img.315fe12c.png";